module.exports = __webpack_public_path__ + "static/media/cliqueiacheiSmall.7c1194bf.svg";